/**
 * Errors a component already reports inline (e.g. ConfirmDialog). The global
 * mutation toast checks this one task later and stays quiet for them, so a
 * failure is reported through exactly one channel.
 */
const handled = new WeakSet<object>();

export function markErrorHandled(error: unknown): void {
  if (error && typeof error === "object") handled.add(error);
}

export function isErrorHandled(error: unknown): boolean {
  return !!error && typeof error === "object" && handled.has(error);
}
